import axios from 'axios'
import qs from 'qs'

let baseUrl = ''

// if (process.env.NODE_ENV === 'development') {
//   baseUrl = ''
// }

class HTTP {
  constructor () {
    this.xhr = axios.create({
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        timeout: 30000,
        withCredentials: true
      }
    })

    this.xhr.interceptors.request.use((opts) => {
      opts.url = baseUrl + opts.url
      return opts
    }, function (error) {
      return Promise.reject(error)
    })

    this.xhr.interceptors.response.use((response) => {
      return response
    }, (error) => {
      return Promise.resolve(error.response)
    })
  }

  request (opts) {
    return this.xhr.request(opts)
      .then(this.checkStatus)
    // .then(this.checCode)
  }

  get (url, opts) {
    opts = opts || {}
    opts.method = 'get'
    opts.url = url

    return this.request(opts)
  }

  /**
   * created by zxl
   * 给get请求动态添加参数
   * @param url
   * @param params
   */
  getWithParam (url, params, opts) {
    if (params && Object.keys(params).length) {
      url += '?'
      const searchText = []
      Object.keys(params).map((p, index) => {
        searchText.push(`${index ? '&' : ''}${p}=${params[p]}`)
      })
      url += searchText.join('')
    }
    return this.get(url, opts)
  }

  post (url, data, opts) {
    opts = opts || {}
    opts.method = 'post'
    opts.url = url
    opts.data = qs.stringify(data)
    opts.headers = opts.headers || {}
    opts.headers = { ...opts.headers, 'Content-Type': 'application/x-www-form-urlencoded' }

    return this.request(opts)
  }

  sendForm (url, data, { method = 'POST', enctype = 'multipart/form-data', target = '_blank' } = {}) {
    const form = document.createElement('form')
    form.action = url
    form.method = method
    form.enctype = enctype
    form.target = target

    const setFiled = (key, val) => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = val
      form.appendChild(input)
    }

    for (const key in data) {
      setFiled(key, data[key])
    }

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  checkStatus (response) {
    if (response && response.status === 200) {
      const { data } = response
      if (data.status === 401) {
        location.replace('/')
      }
    }
    return response
  }
}

export default new HTTP()
